export enum Roles {
  User = "User",
  CountryUser = "Country User",
  CountryAdmin = "Country Admin",
  Admin = "Admin",
  Distributor = "Distributor",
  IndirectCustomer = "Indirect Customer",
}

export enum SortOrder {
  Ascending = "asc",
  Descending = "desc",
  Default = "",
}

export enum ScheduleDueType {
  ServiceDue = 1,
  CalibrationDue = 2,
}

export enum ScheduleDueTypeName {
  ServiceDue = "ServiceDue",
  CalibrationDue = "CalibrationDue",
}

export enum FsVisitType {
  Planned = 1,
  Last = 2,
}

export enum StatusTypes {
  Requested = "requested",
  Received = "received",
  AwaitingPO = "awaitPo",
  InProcess = "inProcess",
  Returning = "returning",
  AtCustomer = "available",
}

export enum DocType {
  EventDocument = "document",
  Certificate = "certificate",
}

export enum ToolCounterType {
  Service = "Service",
  Calibration = "Calibration",
  AwaitingPO = "AwaitingPO",
}

export enum ViewType {
  ToolsOnsite = "onsite",
  ToolsOutForService = "out-for-service",
  ToolsAll = "",
}

export enum Basket {
  ServiceRequest = "tools-basket.ra",
  PurchaseOrder = "tools-basket.po",
}

export enum Schedule {
  Service = "Service",
  Calibration = "Calibration",
}

export enum ReminderType {
  Calibration = 1,
  Service = 2,
  PO = 16,
  Receive = 32,
  Shipping = 64,
}

export enum ReminderInterval {
  Daily = 1,
  Weekly = 2,
  Monthly = 16,
}

export enum SubscriptionType {
  ServiceRequest = "addRa",
  CswCheckIn = "checkin",
  Contracts = "contracts",
  EditTool = "editTool",
  PurchaseOrder = "enterPo",
  FieldService = "fieldService",
  HomeGraphs = "homeGraphs",
  Reminders = "reminders",
  AddTool = "addTool",
  TechCover = "techCover",
}

export enum FilterCategory {
  ModelNumber = "modelNumber",
  ToolSubtype = "subtype",
  Location = "locationName",
  Status = "eventStatus",
  Contract = "contractStatus",
  ServiceDue = "serviceDue",
  Manufacturer = "manufacturer",
  IsActive = "isActive",
}

export enum QuoteReport {
  ToolsInWorkshop,
  ToolsInstalled,
  ToolPlannedVisits,
  Contracts,
  ToolsDueCalibration,
  ToolsDueService,
  ToolLastVisits,
  RedFlaggedItems,
  ContractTools,
  Reminders,
}

export enum EnvironmentType {
  Production = "Production",
  Staging = "Staging",
  Development = "Development",
  Qa1 = "QA 1",
}

export enum ChangelogType {
  Added = "Added",
  Changed = "Changed",
  Fixed = "Fixed",
  Security = "Security",
  Removed = "Removed",
  Deprecated = "Deprecated",
}

export enum BrandType {
  AtlasCopco = "AtlasCopco",
  Desoutter = "Desoutter",
}

export enum LoginStatus {
  LoggedIn, // user logged in
  LoggedOut, // user logged out
  LoginInProgress, // user not yet logged in (any time before the user is fully logged in)
}

export enum TechCoverTicketStatus {
  New = "New", // status 02_New in SF
  InProgress = "InProgress", // all other status in SF
  Closed = "Closed", // status 09_Resolved in SF
}

export enum UnitOfMeasure {
  Metric = "Metric",
  Imperial = "Imperial",
}
